<!--
* @Name：对账单明细明细
* @Author: 刘玉
* @Date: 2021-12-02 15:43:31
* @Last Modified by: 刘玉
* @Last Modified time: 2021-12-02 15:43:31
-->
<template>
  <div>
    <hi-card v-for="(item, index) in detailsInfo" :key="item.id" :row-index="index + 1">
      <van-row>
        <span>物料编码：</span>
        <span>{{ item.materialCode }}</span>
      </van-row>
      <van-row>
        <span>物料描述：</span>
        <span>{{ item.materialDescribe }}</span>
      </van-row>
      <van-row>
        <span>结算数量：</span>
        <span>{{ item.statementQty }}</span>
      </van-row>
      <van-row>
        <span>含税单价：</span>
        <span>{{ item.unitPrice }}</span>
      </van-row>
      <van-row>
        <span>税额：</span>
        <span>{{ item.taxAmount }}</span>
      </van-row>
      <van-row>
        <span>价税合计：</span>
        <span>{{ item.tatalAmountTax }}</span>
      </van-row>
      <van-row>
        <span>未税金额：</span>
        <span>{{ item.amountNoTax }}</span>
      </van-row>
      <van-row>
        <span>收货单号：</span>
        <span>{{ item.asnNo }}</span>
      </van-row>
      <van-row>
        <span>行号：</span>
        <span>{{ item.asnItemNo }}</span>
      </van-row>
    </hi-card>
  </div>
</template>

<script>
export default {
  name: 'AccountOrderDetails',
  data() {
    return {
      detailsVisible: false
    }
  },
  props: {
    detailsInfo: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    viewDetailsInfo() {
      this.detailsVisible = true
    }
  }
}
</script>
